module.exports = __webpack_public_path__ + "img/back.3478ae5a.jpg";